import React, { useState } from "react";

const ToolTip = ({ platform, url, src }) => {
  const [isTooltipVisible, setIsToolTipVisible] = useState({
    linkedin: false,
    leetcode: false,
    github: false,
    twitter: false,
    medium: false,
  });

  const handleToolTip = (platform, trigger) => {
    const tooltip = { ...isTooltipVisible };
    switch (platform) {
      case "linkedin":
        if (trigger) {
          tooltip.linkedin = true;
        } else {
          tooltip.linkedin = false;
        }
        break;
      case "leetcode":
        if (trigger) {
          tooltip.leetcode = true;
        } else {
          tooltip.leetcode = false;
        }
        break;
      case "github":
        if (trigger) {
          tooltip.github = true;
        } else {
          tooltip.github = false;
        }
        break;
      case "twitter":
        if (trigger) {
          tooltip.twitter = true;
        } else {
          tooltip.twitter = false;
        }
        break;
      case "medium":
        if (trigger) {
          tooltip.medium = true;
        } else {
          tooltip.medium = false;
        }
        break;
      default:
        console.log("Icons Not Selected");
    }
    setIsToolTipVisible(tooltip);
  };

  return (
    <div className="tooltipContainer">
      <img
        onMouseEnter={() => {
          handleToolTip("linkedin", true);
        }}
        onMouseLeave={() => {
          handleToolTip("linkedin", false);
        }}
        onClick={() => window.open(url, "_blank")}
        style={{ width: "1.7rem", filter: "invert(1)", cursor: "pointer" }}
        src={src}
        alt="Tooltip"
      />
      {isTooltipVisible.linkedin && <div className="tooltip">{platform}</div>}
    </div>
  );
};

export default ToolTip;
